/**
 * TSURATSURA Dawn Base Theme v3.1
 * ts-recently-viewed.js — 最近見た商品
 * localStorageに閲覧商品のhandleを保存。Storefront API経由で表示。
 */

class TSRecentlyViewed {
  constructor() {
    this.storageKey = 'ts_recently_viewed';
    this.maxItems = 10;
    this.items = [];
    this.init();
  }

  init() {
    this.load();
    this.trackCurrentProduct();
    this.render();
  }

  load() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      this.items = stored ? JSON.parse(stored) : [];
    } catch (_e) {
      this.items = [];
    }
  }

  save() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    } catch (_e) {
      // localStorage使用不可
    }
  }

  trackCurrentProduct() {
    const productEl = document.querySelector('[data-ts-recently-viewed-track]');
    if (!productEl) return;

    const handle = productEl.getAttribute('data-ts-recently-viewed-track');
    const title = productEl.getAttribute('data-ts-product-title') || '';
    const image = productEl.getAttribute('data-ts-product-image') || '';
    const price = productEl.getAttribute('data-ts-product-price') || '';
    const url = productEl.getAttribute('data-ts-product-url') || window.location.pathname;

    if (!handle) return;

    this.items = this.items.filter((item) => item.handle !== handle);
    this.items.unshift({ handle, title, image, price, url });

    if (this.items.length > this.maxItems) {
      this.items = this.items.slice(0, this.maxItems);
    }

    this.save();
  }

  async render() {
    const container = document.querySelector('[data-ts-recently-viewed-container]');
    if (!container) return;

    const currentHandle = document.querySelector('[data-ts-recently-viewed-track]')
      ?.getAttribute('data-ts-recently-viewed-track');

    const displayItems = this.items.filter((item) => item.handle !== currentHandle);

    if (!displayItems.length) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';
    const grid = container.querySelector('.ts-recently-viewed__grid');
    if (!grid) return;

    grid.innerHTML = '';

    displayItems.slice(0, 6).forEach((item) => {
      const card = document.createElement('a');
      card.href = item.url;
      card.className = 'ts-recently-viewed__card';
      card.innerHTML = `
        <div class="ts-recently-viewed__image-wrap">
          <img src="${this.escapeHtml(item.image)}" alt="${this.escapeHtml(item.title)}" loading="lazy" width="200" height="200">
        </div>
        <div class="ts-recently-viewed__info">
          <p class="ts-recently-viewed__title">${this.escapeHtml(item.title)}</p>
          <p class="ts-recently-viewed__price">${this.escapeHtml(item.price)}</p>
        </div>
      `;
      grid.appendChild(card);
    });
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  clear() {
    this.items = [];
    this.save();
    this.render();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.tsRecentlyViewed = new TSRecentlyViewed();
});
